const IfscCommon = {
  address:"http://beian.miit.gov.cn",
  friend:"https://www.wengold.com/webss/ifsc/platform/#/",
  download:"https://www.wengold.com:1443/ifsc/s/apppkg/ifsc_release.apk"
}

export default IfscCommon;